import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import store from './store'
import './styles/app.scss';
// import 'bootstrap/dist/css/bootstrap.min.css';

const el = document.getElementById('reactApp');
ReactDOM.render(<App store={store}/>, el);
